import { useState, useEffect } from 'react'

const AirportDropdown = ({ label, setFormData, formData }) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedAirport, setSelectedAirport] = useState('')
  const [airports, setAirports] = useState([])
  const [filteredAirports, setFilteredAirports] = useState([])
  const [showDropdown, setShowDropdown] = useState(false)

  useEffect(() => {
    fetch('/PackageJson/Flights/Airports.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch airport data')
        }
        return response.json()
      })
      .then(data => {
        const flatAirports = Object.values(data[0])
        setAirports(flatAirports)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])
  useEffect(() => {
    if (searchTerm.trim()) {
      setFilteredAirports(
        airports.filter(
          airport =>
            airport.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            airport.country?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            airport.city?.toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
    } else {
      setFilteredAirports(airports)
    }
  }, [searchTerm, airports])

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
    setShowDropdown(true)
  }
  const handleSelectAirport = airport => {
    setSearchTerm(airport.city)
    setSelectedAirport(airport)
    setShowDropdown(false)
    setFormData(prevState => ({
      ...prevState,
      ToAirport:
        '' +
        airport.name +
        ',' +
        'city:' +
        airport.city +
        ',' +
        'state:' +
        airport.state +
        ',' +
        'country:' +
        airport.country
    }))
  }
  const getCountryFlag = countryCode =>
    `https://flagcdn.com/w80/${countryCode.toLowerCase()}.png`
  const handleFocus = () => {
    setShowDropdown(true)
    setSearchTerm('')
    setSelectedAirport('')
  }
  useEffect(() => {
    if (formData.ToAirport === '') {
      setSearchTerm('')
      setSelectedAirport('')
    }
  }, [formData])
  return (
    <div>
      {showDropdown && (
        <div
          onClick={() => setShowDropdown(false)}
          className='GuestCounter-center'
        ></div>
      )}
      <div
        className={`search-input-box flight-from ${showDropdown ? 'open' : ''}`}
        style={{ float: label === 'To' ? 'right' : 'left' }}
      >
        <div
          onClick={() => setShowDropdown(true)}
          style={{
            position: 'absolute',
            left: '0px',
            right: '0px',
            width: '100%',
            height: '100%'
          }}
        ></div>
        <label className='form-label'>{label}</label>
        <div className='form-holder'>
          <input
            className='autocomplete-airport inp-text'
            type='text'
            style={{ position: 'relative' }}
            value={searchTerm}
            onChange={handleSearchChange}
            autoComplete='off'
            onFocus={() => handleFocus()}
            required
          />
          <input type='hidden' name='from' value={`${selectedAirport.city}`} />
          <p className='air-p'>
            <span id='selected-airport'>
              {selectedAirport.icao && (
                <span>
                  {searchTerm === '' ? (
                    ''
                  ) : (
                    <>
                      {selectedAirport.icao}, {selectedAirport.name}
                    </>
                  )}
                </span>
              )}
            </span>
          </p>

          {showDropdown && (
            <div className='select-source'>
              <div className='filter-user'>
                {filteredAirports.slice(0, 100).map(airport => (
                  <div
                    key={airport.icao}
                    className='list-group-item'
                    onClick={() => handleSelectAirport(airport)}
                  >
                    <div className='Flights-left'>
                      <div className='Are-Icons'>
                        <img
                          src='PackageJson/HeaderMenu/Icons/Are.png'
                          width='30px'
                        />
                      </div>
                      <div>
                        <p>
                          {airport.city} - {airport.country}
                        </p>
                        <p>{airport.name}</p>
                      </div>
                    </div>

                    <img
                      src={getCountryFlag(airport.country)}
                      alt={`${airport.country} flag`}
                      style={{ width: '40px' }}
                      className=''
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AirportDropdown
